function initToggle() {
  if (window.matchMedia('(max-width: 768px)').matches) {
    $(".list-side .list-title").off('click.toggle').each(function () {
        var $this = $(this);
        var elementVal = $this.next(".open");
        if (!elementVal.is(":visible")){
            $(this).on('click.toggle', function(){
                elementVal.stop().slideToggle("fast");
                $(this).toggleClass("list-title--on");
            });
        };
    });
  } else {
    $(".list-side .list-title").off('click.toggle');
    $(".list-side .open").removeAttr("style");
    $(".list-side .list-title").removeClass("list-title--on");
  }
}

$(window).on("load resize", function () {
  initToggle();
});


